var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.showAnnounce)?_c('div',{staticClass:"announce_bg"},[_c('svg',{staticClass:"icon common_close",attrs:{"aria-hidden":"true"},on:{"click":_vm.close}},[_c('use',{attrs:{"xlink:href":"#icon-close"}})]),_c('a',{staticClass:"announceBtn",on:{"click":function($event){return _vm.toHuazhiUrl('invest_islogin')}}},[_vm._v("立即体验")])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }